const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiptActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m53 1h-42a1 1 0 0 0 -1 1v60a1 1 0 0 0 1 1h30a1 1 0 0 0 .707-.293l12-12a1 1 0 0 0 .293-.707v-48a1 1 0 0 0 -1-1zm-41 2h40v46h-11a1 1 0 0 0 -1 1v11h-28zm38.586 48-8.586 8.586v-8.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m15 14h34a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1h-34a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1zm1-6h32v4h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m15 18h34a1 1 0 0 0 0-2h-34a1 1 0 0 0 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m15 22h34a1 1 0 0 0 0-2h-34a1 1 0 0 0 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m37 24h-22a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m40 26h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m33 32h-18a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-16v-4h16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m26 42h-11a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m20 46h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptActive);
export default __webpack_public_path__ + "static/media/receipt-active.86d224444d0fb3a083691bcaacca6163.svg";
export { ForwardRef as ReactComponent };